/** « 1500000.5 » → « 1 500 000,5 » (groupes de trois chiffres, virgule décimale). */
export function groupDigits(raw: string): string {
  if (!raw) return "";
  const negative = raw.startsWith("-");
  const [int, dec] = raw.replace("-", "").split(".");
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return `${negative ? "-" : ""}${grouped}${dec !== undefined ? `,${dec}` : ""}`;
}

/** Texte saisi → nombre brut (« 1 500 000,5 » → « 1500000.5 »), sans autre caractère que les chiffres. */
export function toRawNumber(text: string, allowDecimal: boolean, allowNegative: boolean): string {
  const negative = allowNegative && text.trim().startsWith("-");
  let s = text.replace(/,/g, ".").replace(/[^\d.]/g, "");
  if (allowDecimal) {
    const dot = s.indexOf(".");
    if (dot >= 0) s = `${s.slice(0, dot + 1)}${s.slice(dot + 1).replace(/\./g, "")}`;
  } else {
    s = s.replace(/\./g, "");
  }
  return `${negative ? "-" : ""}${s}`;
}
